// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { billingAddressStyles } from "@guestsupply/Overrides/Widgets/CheckoutShipping/BillingAddress";
import { styledScrollbar } from "@guestsupply/XDL/Utilities/scroll";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

billingAddressStyles.container = { gap: 12 };
billingAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        align-items: center;
    `,
};
billingAddressStyles.headingText = {
    variant: "h6",
    as: "p",
    css: css`
        margin-bottom: 0;
    `,
};
billingAddressStyles.selectSavedAddressLink = {
    typographyProps: {
        size: 12,
    },
    css: css`
        margin-left: 20px;
    `,
};
billingAddressStyles.addressBookModal = { sizeVariant: "medium" };
billingAddressStyles.addressBookModalButtonsWrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        margin-top: 1rem;
    `,
};
billingAddressStyles.addressBookModalCancelButton = { variant: "secondary" };
billingAddressStyles.addressDisplayAndFormGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};
billingAddressStyles.headingWrapper = {
    css: css`
        display: flex;
        width: 100%;
        padding-bottom: 8px;
        border-bottom: 1px solid ${getColor("common.border")};
    `,
};
billingAddressStyles.noteswWrapper = {
    css: css`
        margin-top: 15px;
        width: 100%;
    `,
};
billingAddressStyles.notify = {
    css: css`
        margin-top: 15px;
        margin-bottom: 0;
    `,
};
billingAddressStyles.buttonsWrapper = {
    css: css`
        display: flex;
        justify-content: end;
        gap: 10px;
        margin-top: 15px;
    `,
};
billingAddressStyles.addressTypographyStyles = {
    as: "p",
    weight: "bold",
    css: css`
        &&& {
            margin-bottom: 0;
            margin-top: 15px;
        }
    `,
};
billingAddressStyles.radioStyles = {
    css: css`
        padding: 5px;
        border: 1px solid ${getColor("common.border")};
        border-radius: 4px;
    `,
};

billingAddressStyles.resultsWrapper = {
    css: css`
        max-height: 300px;
        padding-right: 5px;
        ${styledScrollbar(4, 0)}
    `,
};

billingAddressStyles.checkoutShippingPageModal = {
    cssOverrides: {
        modalTitle: css`
            &&& {
                border: none;
                min-height: 40px;
            }
        `,
    },
};
